import React from "react";
import { Tooltip } from "@material-tailwind/react";
import PropTypes from "prop-types";

const StyledTooltip = ({ children, content, referencePress=true, ...props }) => {

  if (!children) return null;

  return (
    <Tooltip
      content={content}
      className="bg-white text-blue-500 border-solid border z-[999999] relative whitespace-pre-line"
      referencePress={referencePress} referencePressEvent="click"
      {...props}
    >
      {children}
    </Tooltip>
  )
};

StyledTooltip.propTypes = {
  children: PropTypes.node,
  referencePress: PropTypes.bool,
  content: PropTypes.string.isRequired,
};

export default StyledTooltip;
